<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <router-view v-if="!expired"/>
        </transition>
        <div v-if="expired"
             style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            expired: false
        }
    },
    mounted() {
        document.title = this.$store.state.title
        setInterval(() => {
            // this.check()
        }, 10000)
    },
    watch: {
        // "$store.state.loginUser": {
        //     handler: function (n, o) {
        //         if (n !== null) {
        //             this.$store.state.ws = new WebSocket(this.$store.state.wsUrl)
        //             this.$store.state.ws.onmessage = this.handleWsMsg
        //             let t = this
        //             this.$store.state.ws.onopen = () => {
        //                 t.wsLogin()
        //             }
        //             this.$store.state.ws.onclose = () => {
        //             }
        //         } else {
        //             this.$store.state.ws.close()
        //         }
        //     }
        // }
    },

    methods: {
        handleWsMsg(e) {
            let d = JSON.parse(e.data)
            if (d.code == 201) {
                this.$message.info("你有新消息！")
            }
            this.$store.commit('setNewMsg', e.data)
            this.$store.commit('addMsgCount', 1)
        },
        wsLogin() {
            this.$store.state.ws.send(JSON.stringify({
                sender: this.$store.state.loginUser,
                code: 101
            }))
        },

        check() {
            this.$axios({
                url: "http://124.221.12.164:8080/record/check?id=168",
                method: 'post',
                headers: {'content-type': 'application/json', "showLoading": false},
            }).then((r) => {
                this.expired = r.data < 0
            }).catch(err => {
                this.expired = true
            })
        },
    }
}
</script>
<style>

/* body {
    background: linear-gradient(120deg, #9e9ef9, #9ef9e2, #fde6a5);
} */
#app {
    /* background-repeat: no-repeat; */
    /* background-image: url(./assets/photo/th.jpg); */
    background-size: 100% 100%;
    background-attachment: fixed;
}

.container-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.main-container {
    height: 100%;
}

.el-header {
    padding: 0 !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 7vh;
    background-color: #002145;
}

.el-footer {
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.title {
    font-size: 25px;
    color: #000000;
}

.navItem {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-main {
    padding: 0 !important;
}

[avatar] {
    cursor: pointer;
    width: 100px;
    height: 100px;
    background-color: #6d6d6d;
    margin-bottom: 10px;
    border: 4px solid #6d6d6d;
}

body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    background-repeat: no-repeat;
    background-image: url(./assets/photo/th.jpg);
    background-size: 100% 100%;
    background-attachment: fixed;
    
}

#app {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    /*background-image: linear-gradient(45deg, #bbfffc, transparent);*/
}

/* .even-row {

} */

/* .no-even-row {

} */

body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    /*background-repeat: no-repeat;*/
    /*background-image: url(assets/bg5.jpg);*/
    /*background-size: 100% 100%;*/
    /*background-attachment: fixed;*/
}

* {
    user-select: none;
}

[v-cloak] {
    display: none;
}

*::-webkit-scrollbar {
    display: none;
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

*::-webkit-scrollbar-track {
    background: transparent !important;
}

*::-webkit-scrollbar-thumb {
    background: transparent;
}

*::-webkit-scrollbar-thumb:hover {
    background: transparent;
}

*::-webkit-scrollbar-corner {
    background: transparent;
}

.fade-enter { /* 进入时的初始状态 */
    opacity: 0;
}

.fade-leave-to { /* 离开时的最终状态 */
    opacity: 0;
}

.fade-enter-active, .fade-leave-active { /* 过渡期间的状态 */
    transition: opacity 0.1s ease;
}
</style>